/**
 * These correspond to TaskType#name that we know exist in all backend regions.
 */
export enum TaskTypeNames {
  CUSTOM_TASK = "custom",
  PRODUCT_ISSUE = "productIssue",
  PRODUCT_QUALITY = "productQualityReport",
  MEDIA_MAINTENANCE_SINGLE_MEDIA = "mediaMaintenanceSingleMedia",
  MFAQ_FOLLOW_UP = "mfaqFollowUp",
  MEDIA_MAINTENANCE_MULTIPLE_MEDIA = "mediaMaintenanceMultipleMedia",
  ADDON_ORDER = "addonOrder",
  TESTBUY_FOLLOW_UP = "testBuyFollowUp",
  TESTBUY = "testbuy",
}

// Media maintenance task type names array for filtering
export const MEDIA_TASK_TYPE_NAMES = [
  TaskTypeNames.MEDIA_MAINTENANCE_SINGLE_MEDIA,
  TaskTypeNames.MEDIA_MAINTENANCE_MULTIPLE_MEDIA,
] as const;

// UUID v1 pattern for identifying legacy tasks
export const UUID_V1_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Default pagination size for v2 tasks
export const DEFAULT_TASK_PAGE_SIZE = 20;
